module.exports = __webpack_public_path__ + "img/google play@2x.8ed1f6ed.png";